import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("img", {
        src: _ctx.logo,
        alt: "BMWGroup, BMW, MINI logos"
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("main", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("footer", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Hinweise", -1)
        ]))]),
        _: 1
      }),
      _cache[3] || (_cache[3] = _createTextVNode(" | ", -1)),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Datenschutz", -1)
        ]))]),
        _: 1
      }),
      _cache[4] || (_cache[4] = _createTextVNode(" | ", -1)),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Impressum", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}